
(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.lightbox = {
    attach: function (context, settings) {
      $('body', context).once('lightbox').each(function () {
        if ($("[data-lightbox]").length) {
          lightbox.option({
            'wrapAround': true
          });
        }
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
